import { AbstractControl, Validators } from '@angular/forms';
import { electronicFormatIBAN, isValidIBAN } from 'ibantools';

export class BankAccountValidator {
  static validBankAccountNumber(control: AbstractControl) {
    const czyWpisanyNumerKonta =
      !!control.value && control.value.replace(/[^0-9]+/g, '').length !== 0;

    return czyWpisanyNumerKonta &&
      BankAccountValidator.isValidBankAccountNumber(control.value)
      ? null
      : {
          ['invalidBankAccountNumber']: true,
        };
  }

  static validUEBankAccountNumber(control: AbstractControl) {
    if (!control.value) {
      return null;
    }

    const iban = electronicFormatIBAN(control.value);
    const validIBAN = isValidIBAN(iban!);

    return validIBAN
      ? null
      : {
          ['invalidBankAccountNumber']: true,
        };
  }

  public static isBankAccountNumberEntered(control: AbstractControl) {
    return (
      control &&
      !!control.value &&
      control.value.replace(/[^0-9]+/g, '').length !== 0
    );
  }

  private static isValidBankAccountNumber(nrb: string): boolean {
    nrb = nrb.replace(/[^0-9]+/g, '');
    if (nrb.length < 26) {
      return false;
    }
    const Wagi = [
      1, 10, 3, 30, 9, 90, 27, 76, 81, 34, 49, 5, 50, 15, 53, 45, 62, 38, 89,
      17, 73, 51, 25, 56, 75, 71, 31, 19, 93, 57,
    ];

    if (nrb.length === 26) {
      nrb = nrb + '2521';
      nrb = nrb.substr(2) + nrb.substr(0, 2);
      let Z = 0;
      for (let i = 0; i < 30; i++) {
        Z += +nrb[29 - i] * Wagi[i];
      }
      return Z % 97 === 1;
    } else {
      return false;
    }
  }

  static onlyBigLettersAndNumbersValidator(control: AbstractControl) {
    const func = Validators.pattern('[A-Z0-9]*');
    const errors = func(control);
    if (!errors) {
      return null;
    }

    return {
      ['incorrectPattern']: true,
    };
  }
}
